import { useState, useEffect } from "react";
import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import LoginImage from '../images/buyer-seller-signup2.jpg';
import Navmain from '../main/header';
import Footer from '../main/footer';
import buyer from '../images/buyer.jpg'
import hover_buyer from '../images/hover_buyer.jpg'
import seller from '../images/seller.jpg'
import hover_seller from '../images/hover_seller.jpg'

function Login() {
  const navigate = useNavigate();
  const [passShow, setpassShow] = useState(false);
  const [passShow2, setpassShow2] = useState(false);
  const [error, seterror] = useState("");
  const [name, setName] = useState("");
  const [cname, setCname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pass, setPass] = useState("");
  const [pas2, setPass2] = useState("");
  const [cityName, setCityName] = useState("");
  const [cityIndex, setCityIndex] = useState();
  const [province, setProvince] = useState("");
  const [listcities, setCitiesList] = useState([]);

  const [main, setMainCat] = useState([]);
  const [cat, setCat] = useState("");

  const [address, setAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [userType, setUserType] = useState(""); // buyer/seller/both
  const [isWhatsapp, setIsWhatsapp] = useState("no"); // optional, 'yes' or ''

  useEffect(() => {

    const aa = localStorage.getItem("USER");
    if (aa != null) {
      navigate("/");
    }
    // Fetching IP and location data from ipinfo.io
  fetch('https://api.ipify.org?format=json')
  .then(response => response.json())
  .then(data => {
    const ip = data.ip;

    // Fetch location details using ipinfo.io
    fetch(`https://ipinfo.io/${ip}/json?token=43c56c45969332`)
      .then(response => response.json())
      .then(locationData => {
        const city = locationData.city;
        const region = locationData.region;

        // Set city and province
        setCityName(city);
        setProvince(region);
      })
      .catch(error => console.log('Error fetching location data:', error));
  })
  .catch(error => console.log('Error fetching IP:', error));
  
    getCities()
    getMainCat()

  }, []);

  const getMainCat = async () => {
    const data = new FormData();
    data.append('uid', 'ss');

    axios({
      method: 'post',
      url: '/pro/cat/maincat.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        console.log('Main cat list ', s.data);
        const a = s.data;
        setMainCat(a);
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const ValidateEmail = (inputText) => {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.match(mailformat)) {
      return true;
    } else {

      return false;
    }
  }
  const getCities = async () => {
    const data = new FormData();

    axios({
      method: "post",
      url: "/pro/auth/cities_list.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setCitiesList(s.data)
      })
      .catch((s) => {

      });


  };
  const text_type = (input) => {
    // Regular expression to check if the string contains only alphabetic characters
    const regex = /^[A-Za-z\s]+$/;

    // Test the input against the regular expression
    return regex.test(input);

  }

  const SigupReady = () => {
    setIsLoading(true); // Start loading

    const data = new FormData();
    data.append("name", name);
    data.append("cname", cname);
    data.append("email", email);
    data.append("phone", phone);
    data.append("city", cityName);
    data.append("address", address);
    data.append("pass", pass);
    data.append("province", province);
    data.append("img", "");
    data.append("cnic", pass);
    data.append("cat", cat);
    data.append("user_type", userType); // 👈 New required field
    data.append("is_whatsapp", isWhatsapp); // 👈 Optional field

    axios({
      method: "post",
      url: "/pro/auth/reg.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setIsLoading(false); // Stop loading
        console.log("signup response", s.data);
        if (s.data[0].code === "pass") {
          if(s.data[0].message) {
            alert(s.data[0].message);
          } else {
            alert("You have been successfully registered.");
          }
          
          localStorage.setItem("signupDetails", JSON.stringify({ phone, pass }));
          localStorage.setItem("currentPhone", phone);
          navigate("/otp");
        } else if (s.data[0].code === "already") {
          alert("Account is already existed.");
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((err) => {
        setIsLoading(false); // Stop loading on error
        console.error(err);
      });
  };

  const SignUpNow = async () => {

    if (userType === "") {
      seterror("userType");
      alert("Please select Buyer or Seller");
    } else if (name === "") {
      seterror("name");
      alert("Enter Name");
    } else if (userType === "seller" && cname === "") {
      seterror("cname");
      alert("Enter Company Name");
    } else if (phone === "") {
      seterror("phone");
      alert("Enter Phone Number");
    } else if (phone.length < 9) {
      seterror("phone");
      alert("Enter a valid Phone Number");
    } else if (pass !== pas2) {
      seterror("pass");
      alert("Passwords do not match!");
    } else if (pass.length < 8) {
      seterror("pass");
      alert("Password must be at least 8 characters");
    } else {
      if (email === "") {
        SigupReady();
      } else {
        if (ValidateEmail(email)) {
          SigupReady();
        } else {
          alert("Enter valid Email");
          seterror("email");
        }
      }
    }
    

  };

  return (
    <div>
    <Navmain />
    <main className="main">
      <section className="bg-home9 no-gutters">
      <div className="container d-flex justify-content-center align-items-center">
      <div className="row w-100">
      <div className="col-5 d-none d-lg-block p-2">
    <div className="py-4 border-0 rounded login-content"
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden' // Prevents any overflow outside the container
      }}
    >
      <img 
        className="form-image"
        src={LoginImage} 
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover' // Ensures the image covers the entire div without distortion
        }}
      />
    </div>
</div>

<div className="col-lg-7 col-12">
          <div className="py-4 border-0 rounded login-content">
                <div style={{ opacity: 0.9 }} className="login-form">
                <h4 style={{ fontSize: '22px', color: '#1D2630', marginTop: "30px", letterSpacing: '1.4px' }} className="font-bold main-heading-style">Register Now  </h4>
                {/* <h4 className="text-uppercase">
                </h4> */}
                {/* <center
                  style={{
                    marginBottom: '50px'
                  }}
                >
                  <img

                    onClick={() => {
                      navigate("/");
                    }}
                    style={{
                      // marginTop: "20px",
                      cursor: "pointer",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    src="assets/images/logob.png"
                    height={90}
                  />
                </center> */}

<div className="row px-3">
<label className="mb-4"><i class="fas fa-user-tag mr-2"></i> Please choose your account type to continue</label>
  <div className="col-6 text-center mb-4">
    <img
      src={userType === "buyer" ? hover_buyer : buyer}
      alt="Buyer"
      className="img-fluid rounded shadow-sm"
      onClick={() => setUserType("buyer")}
      style={{
        cursor: 'pointer',
        // border: userType === "buyer" ? "3px solid #2C99A1" : "1px solid #ccc",
        borderRadius: "10px",
        transition: "0.3s",
        maxHeight: "200px",
        objectFit: "contain"
      }}
    />
    <label className="mt-2 fw-bold">Buyer</label>
  </div>
  <div className="col-6 text-center mb-4">
    <img
      src={userType === "seller" ? hover_seller : seller}
      alt="Seller"
      className="img-fluid rounded shadow-sm"
      onClick={() => setUserType("seller")}
      style={{
        cursor: 'pointer',
        // border: userType === "seller" ? "3px solid #2C99A1" : "1px solid #ccc",
        borderRadius: "10px",
        transition: "0.3s",
        maxHeight: "200px",
        objectFit: "contain"
      }}
    />
    <label className="mt-2 fw-bold">Seller</label>
  </div>
</div>



<div
  style={{
    filter: userType === "" ? "blur(-1px)" : "none",
    pointerEvents: userType === "" ? "none" : "auto",
    opacity: userType === "" ? 0.6 : 1,
    transition: "all 0.3s ease-in-out"
  }}
>
                <div className="row px-3">
                <div
  className={`form-group mb-0  ${error === "name" ? "has-error" : ""} ${userType === "seller" ? "col-md-6" : "col-md-12"}`}
>
                    <label><i class="fas fa-user mr-2"></i>Enter Full Name <span style={{color:'red'}}>*</span></label>
                    <input
                      // style={{border: '1px solid #EFEFEF'}}
                      type="text"
                      className="form-control rounded"
                      placeholder="Enter Full Name"
                      maxLength={30}
                      value={name}
                      onChange={(v) => {

                        if (text_type(v.target.value)) {
                          setName(v.target.value);
                        } else if (v.target.value == "") {
                          setName(v.target.value);
                        }

                      }}
                    />
                  </div>
{/* ✅ Company Name for SELLER shown at top */}
{userType === "seller" && (
      <div className={error === "cname" ? "form-group mb-0  col-md-6 has-error" : "form-group mb-0  col-md-6"}>
        <label>
          <i className="fas fa-building mr-2"></i>
          Company Name <span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          className="form-control rounded"
          placeholder="Company Name"
          value={cname}
          maxLength={30}
          onChange={(v) => {

                        if (text_type(v.target.value)) {
                          setCname(v.target.value);
                        } else if (v.target.value == "") {
              setCname(v.target.value);
            }
          }}
        />
      </div>
    )}


                  <div className={error == "phone" ? "form-group mb-0  col-md-6 has-error" : "form-group mb-0  col-md-6"} >
                    <div class="">
                      <label><i class="fas fa-phone mr-2"></i>Phone No. <span style={{color:'red'}}>*</span></label>
                      <div class="input-group  rounded">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroupPrepend">+92</span>
                        </div>
                        <input type="text" placeholder="Phone No." aria-describedby="inputGroupPrepend" className="form-control" value={phone} onChange={(v) => {
                          let newValue = v.target.value;
                          newValue = newValue.replace(/[.-]/g, "");

                          // Update the state with the valid value
                          // setPhone(newValue);

                          if (newValue.charAt(0) === "0") {
                            newValue = "";  // Clear the value if the user is trying to type '0' as the first character
                            return;
                          }
                          if (newValue.length <= 10) {
                            if (!text_type(newValue)) {
                              setPhone(newValue);
                            }
                          } else {
                            alert("Enter valid Phone Number")
                          }

                          // setPhone(newValue);
                          // if (v.target.value.length <= 10) {
                          //   if (!text_type(v.target.value)) {
                          //     setPhone(v.target.value);
                          //   }

                          //   if (checkValue[0] == '0') {
                          //     console.log('check if', newValue);
                          //     setPhone(newValue);
                          //   }
                          // } else {
                          //   alert("Enter valid Phone Number")
                          // }

                        }} />
                      </div>
                    </div>
                  </div>



                {/* <div className="form-group mb-0 ">
                    <label>CNIC No.</label>
                    <input
                    type="text"
                    className="form-control"
                      placeholder="Enter CNIC No."
                      pattern="^[0-9]*[.,]?[0-9]*$"
                      value={cnic}
                      onChange={(v) => {
                        const a = v.target.value;

                        if (a.length === 5) {
                          setCnic(a + "-");
                        } else if (a.length === 13) {
                          setCnic(a + "-");
                        } else if (a.length == 16) {
                        } else {
                          setCnic(v.target.value);
                        }
                      }}
                    />
                  </div> */}

                {/* Adress Start */}
                {/* <div className="form-group mb-0 ">
                    <label>Address</label>
                    <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Address"
                      onChange={(v) => {
                        setAddress(v.target.value);
                      }}
                    />
                  </div> */}

                {/* <div className="row">
                  <div  className= {error =="city"?"form-group mb-0  col-6 has-error":"form-group mb-0  col-6"} >
                    <label>City</label>
                    <select
                      value={cityIndex}
                      onChange={(v) => {

                          setCityIndex(v.target.value);
                          setCityName(listcities[v.target.value].city)
                          setProvince(listcities[v.target.value].admin_name)

                      }}
                      className="form-control"
                    >
                  {
                  listcities.map((v,i)=>(
<>
<option value={i} >{v.city}</option>
</>
                  ))
                  }
                    </select>
                  </div>


                    <div  className= {error =="add"?"form-group mb-0  col-6 has-error":"form-group mb-0  col-6"} >
                      <label>Address (optional)</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Address"
                        value={address}
                        onChange={(v) => {
                          setAddress(v.target.value);
                        }}
                      />
                    </div>
                    </div> */}


                {/* <div className="row" >
                              <div className="col-12 form-group mb-0 ">
                              <label>Select Main Category</label>
                                <select
                                style={{ borderColor: error==false?"black":cat==""?"red":"black" }}
                                  value={cat}
                                  onChange={ve => {
                                    setCat(ve.target.value)
                                  }}
                                  className="form-control">
                                  <option>Select Main Category</option>

                                  {main.map((v, i) => (
                                    <option value={v.id}>{v.title}</option>
                                  ))}
                                </select>
                              </div>
                            </div> */}



                  
     

                  
                  <div className="form-group mb-0  col-xl-6 col-lg-12">
                  <div className="">
  <label><i class="fas fa-comment-dots mr-2"></i>WhatsApp Registered <span style={{color:'red'}}>*</span>
    </label>
  <div className="form-control d-flex gap-2 pt-2">
    <div className="form-check mb-0">
      <input
        className="form-check-input"
        type="radio"
        name="isWhatsapp"
        value="yes"
        checked={isWhatsapp === "yes"}
        onChange={(e) => setIsWhatsapp(e.target.value)}
        id="radioYes"
      />
      <label className="form-check-label" htmlFor="radioYes">
        Yes
      </label>
    </div>
    <div className="form-check  mb-0">
      <input
        className="form-check-input"
        type="radio"
        name="isWhatsapp"
        value="no"
        checked={isWhatsapp === "no"}
        onChange={(e) => setIsWhatsapp(e.target.value)}
        id="radioNo"
      />
      <label className="form-check-label" htmlFor="radioNo">
        No
      </label>
    </div>
  </div>
  </div>
</div>

<div className={error == "pass" ? "form-group mb-0  col-md-6 has-error" : "form-group mb-0  col-md-6"}>
                  <label><i class="fas fa-lock mr-2"></i>Password <span style={{color:'red'}}>*</span></label>
                    <div className="input-group mb-3  rounded">
     

                      <input
                        name="password"
                        type={passShow ? "text" : "password"}
                        onChange={(v) => {
                          setPass(v.target.value);
                        }}
                        value={pass}
                        autoComplete="new-password"
                        className="input form-control"
                        placeholder="password"
                      />
                      <div
                        onClick={() => {
                          setpassShow(!passShow);
                        }}
                        className="input-group-append"
                      >
                        <span className="input-group-text">
                          {passShow ? (
                            <>
                              <i className="fas fa-eye-slash" id="hide_eye"></i>
                            </>
                          ) : (
                            <i className="fas fa-eye" id="show_eye"></i>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className={error == "pass" ? "form-group mb-0  col-md-6 has-error" : "form-group mb-0  col-md-6"}>
                  <label><i class="fas fa-lock mr-2"></i>Confirm Password <span style={{color:'red'}}>*</span></label>
                    <div className="input-group mb-3  rounded">
                      

                      <input
                        name="Confirm Password"
                        type={passShow2 ? "text" : "password"}
                        onChange={(v) => {
                          setPass2(v.target.value);
                        }}
                        value={pas2}
                        autoComplete="new-password"
                        className="input form-control"
                        placeholder="password"
                      />
                      <div
                        onClick={() => {
                          setpassShow2(!passShow2);
                        }}
                        className="input-group-append"
                      >
                        <span className="input-group-text">
                          {passShow2 ? (
                            <>
                              <i className="fas fa-eye-slash" id="hide_eye"></i>
                            </>
                          ) : (
                            <i className="fas fa-eye" id="show_eye"></i>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className={error == "email" ? "form-group mb-0  col-md-6 has-error" : "form-group mb-0  col-md-6"} >
                    <label><i class="fas fa-envelope mr-2"></i>Email (optional) </label>
                    <input
                      type="email"
                      className="form-control rounded"
                      placeholder="Email"

                      onChange={(v) => {
                        setEmail(v.target.value);
                      }}
                    />
                  </div>
                  
    {/* ✅ Company Name again at the bottom for buyer */}
    {userType === "buyer" && (
      <div className="form-group mb-0  col-md-6">
        <label><i className="fas fa-building mr-2"></i>Company Name (optional)</label>
        <input
          type="text"
          className="form-control rounded"
          placeholder="Company Name"
          value={cname}
          maxLength={30}
          onChange={(v) => {

            if (text_type(v.target.value)) {
              setCname(v.target.value);
            } else if (v.target.value == "") {
  setCname(v.target.value);
}
}}
        />
      </div>
    )}

                  {/* <div className="form-group mb-0 ">
                    <label>Add Image</label>y
                    <br />
                    <input
                      className="form-control"
                      type="file"
                      onChange={(v) => {
                        setImg(v.target.files[0]);
                      }}
                    />
                  </div> */}

                  {/* <div className="checkbox">
                    <label>
                      <input type="checkbox" /> Agree the terms and policy
                    </label>
                  </div> */}
                  <div className={error == "pass" ? "form-group mb-0  col-md-12 has-error" : "form-group mb-0  col-md-12"}>

                    <button
                      type="submit"
                      onClick={() => {
                        SignUpNow();
                      }}
                      className="btn btn-flat m-b-30 m-t-30"
                      disabled={isLoading} // Disables the button when loading
                      style={{
                        color: 'whitesmoke',
                        borderRadius: '30px',
                        boxShadow: 'rgb(204, 204, 204) 0px 0px 17px 6px',
                        backgroundColor: '#2C99A1',
                        border: '1px solid #2C99A1',
                        fontSize: '16px',
                        fontWeight: 500
                      }}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"

                          ></span>
                          {" "}Please Wait...
                        </>
                      ) : (
                        "Sign Up"
                      )}
                    </button>
                  </div>
               
                </div>
                </div>
                <div className={error == "pass" ? "form-group mb-0  col-md-12 has-error" : "form-group mb-0  col-md-12"}>
                    <div className="register-link m-t-15 text-center">
                      <Link to={"/login"}>
                        <span style={{ color: '#868e96' }}>Already have account? </span>
                        <span style={{ color: "#45ACB3" }}>
                          Sign in
                        </span>
                      </Link>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>
      </main>
      <Footer />
    </div>
  );
}

export default Login;
